import UTIF from 'utif';

export async function convertTiffToJpeg(file) {
  try {
    // Читаем файл как ArrayBuffer
    const arrayBuffer = await file.arrayBuffer();
    
    // Декодируем TIFF
    const ifds = UTIF.decode(arrayBuffer);
    const firstPage = ifds[0];  // Берём первую страницу TIFF
    
    // Преобразуем TIFF в RGB данные
    UTIF.decodeImage(arrayBuffer, firstPage);
    const rgba = UTIF.toRGBA8(firstPage);

    // Создаём canvas для преобразования в JPEG
    const canvas = document.createElement('canvas');
    canvas.width = firstPage.width;
    canvas.height = firstPage.height;
    
    // Получаем контекст и создаём ImageData
    const ctx = canvas.getContext('2d');
    const imgData = ctx.createImageData(canvas.width, canvas.height);
    imgData.data.set(rgba);
    ctx.putImageData(imgData, 0, 0);

    // Конвертируем canvas в JPEG blob
    const jpegBlob = await new Promise(resolve => {
      canvas.toBlob(resolve, 'image/jpeg', 0.85);
    });

    // Создаём URL для скачивания
    const url = URL.createObjectURL(jpegBlob);
    
    // Генерируем имя файла
    const originalName = file.name.split('.')[0];
    const newName = `${originalName}.jpeg`;

    return {
      url,
      name: newName,
      size: jpegBlob.size
    };
  } catch (error) {
    console.error('Error converting TIFF to JPEG:', error);
    throw error;
  }
}
